import { PASSWORD_MIN } from "@ewn/shared";

/**
 * What every screen that asks for a new password says about it.
 *
 * The floor comes from `@ewn/shared`, where the worker reads it. "They do not
 * match" is only ever checked in a browser, because the worker never sees the
 * second box, so its words live here rather than in a refusal.
 */
export const NEW_PASSWORD_HINT =
  `At least ${PASSWORD_MIN} characters. A passphrase is stronger than anything a rule produces.`;

export const PASSWORDS_DIFFER = "Those two passwords are not the same";
